// importConfigs.js
import { getLightPropostasVendas, getVendas } from '../../../api';

export const importConfigs = {
  propostas: {
    fetchFunction: getLightPropostasVendas,
    tableTitles: ['Cliente','Usuário', 'Abertura', 'Fluxo', 'Etapa', 'Data', 'Valor'],
    tableFields: [
      { path: 'cliente.nome' },
      { path: 'user.nome' },
      { path: 'user2.nome' },
      { path: 'fluxo.nome' },
      { path: 'etapa.nome' },
      { path: 'data', type: 'date' },
      { path: 'valor', type: 'currency' },
    ],
    filterFn: (item, term) =>
      item.cliente?.nome?.toLowerCase().includes(term) ||
      item.user?.nome?.toLowerCase().includes(term) ||
      item.user2?.nome?.toLowerCase().includes(term) ||
      item.data?.includes(term),
  },
  vendas: {
    fetchFunction: getVendas,
    tableTitles: ['Cliente','Vendedor Abertura', 'Vendedor Fechamento', 'Data', 'Valor'],
    tableFields: [
      { path: 'cliente.nome' },
      { path: 'vendedorAbertura.nome' },
      { path: 'vendedorFechamento.nome' },
      { path: 'data', type: 'date' },
      { path: 'valor', type: 'currency' },
    ],
    filterFn: (item, term) =>
      item.cliente?.nome?.toLowerCase().includes(term) ||
      item.vendedorAbertura?.nome?.toLowerCase().includes(term) ||
      item.vendedorFechamento?.nome?.toLowerCase().includes(term) ||
      item.data?.includes(term),
  },
};
